module.exports = __webpack_public_path__ + "static/media/recruit_780_art.8d7cdc0f.png";